import { useTranslation } from "react-i18next";

const steps = [
  { icon: "ri-search-line", color: "bg-primary-100 text-primary-600" },
  { icon: "ri-file-list-3-line", color: "bg-accent-100 text-accent-600" },
  { icon: "ri-arrow-right-circle-line", color: "bg-secondary-100 text-secondary-700" },
];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 bg-background-100">
      <div
        className="absolute inset-0 opacity-[0.03] bg-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Subtle%20minimalist%20organic%20wave%20pattern%20on%20cream%20background%2C%20clean%20modern%20design%20element%2C%20very%20light%20and%20barely%20visible%2C%20Scandinavian%20textile%20pattern%20style%2C%20soft%20flowing%20lines%2C%20neutral%20warm%20aesthetic&width=400&height=400&seq=how-bg-pattern-v3&orientation=squarish&nocache=true)`,
        }}
      ></div>
      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {t("how.title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("how.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step, idx) => (
            <div key={idx} className="relative text-center">
              <div className={`w-16 h-16 md:w-18 md:h-18 rounded-2xl flex items-center justify-center mx-auto mb-5 ${step.color}`}>
                <i className={`${step.icon} text-2xl`}></i>
              </div>
              <div className="absolute top-8 left-[calc(50%+40px)] hidden md:block">
                {idx < 2 && (
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-foreground-300 text-xl"></i>
                  </div>
                )}
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                {t(`how.step${idx + 1}.title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed max-w-xs mx-auto">
                {t(`how.step${idx + 1}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}